export const autoAdjustFieldHeight = (e, text, hiddenDivIdx) => {
    /**
     * Temporary hidden div to avoid firefox browser scrollbar bug on textarea height change.
     * This div keeps track of the text area properties, without needing to reset the height of the textarea.
     */
    const styles = window.getComputedStyle(e.target);
    const hiddenDiv = document.getElementById(`hidden-div-${hiddenDivIdx}`);
    hiddenDiv.style.width = styles.width;
    hiddenDiv.style.visibility = "hidden";
    hiddenDiv.style.position = "absolute";
    hiddenDiv.style.whiteSpace = "pre-wrap";
    hiddenDiv.style.wordWrap = "break-word";
    hiddenDiv.style.fontFamily = styles.fontFamily;
    hiddenDiv.style.fontSize = styles.fontSize;
    hiddenDiv.style.lineHeight = styles.lineHeight;
    hiddenDiv.style.padding = styles.padding;
    hiddenDiv.style.boxSizing = styles.boxSizing;
    hiddenDiv.textContent = e.target.value + "\n";

    const newHeight = hiddenDiv.scrollHeight;
    e.target.style.height = newHeight + "px";
};


// WEBPACK FOOTER //
// ./src/components/common/FieldHelper.js